"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { ChevronRight, Shield, Calendar, ArrowLeft } from "lucide-react";
import { ICMS } from "@/types/home.types";
import { createLookupObject } from "@/utils/helper";

interface PrivacyPolicyContentProps {
  cmsData?: ICMS[];
}

export function PrivacyPolicyContent({ cmsData }: PrivacyPolicyContentProps) {
  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, ICMS>>({});

  useEffect(() => {
    if (cmsData && cmsData.length > 0) {
      setLookUpCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  return (
    <div className="min-h-screen bg-gray-50/50 flex flex-col font-sans">
      {/* Dynamic Top Decorative Gradient Bar */}
      <div className="bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 h-1.5 w-full"></div>

      <div className="flex-grow py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-6">
          {/* Breadcrumbs */}
          <nav className="flex items-center justify-center gap-2 text-sm text-gray-500 mb-8 font-sans">
            <Link href="/" className="hover:text-pink-600 transition">
              Home
            </Link>
            <ChevronRight className="w-3.5 h-3.5 text-gray-400" />
            <span className="text-gray-900 font-medium">Privacy Policy</span>
          </nav>

          {/* Title Header Section */}
          <div className="mb-10 text-center flex flex-col items-center justify-center">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-pink-50 rounded-2xl mb-4 border border-pink-100">
              <Shield className="w-6 h-6 text-pink-600" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 font-sans mb-3 leading-tight">
              Privacy Policy
            </h1>
            <div className="flex items-center justify-center gap-2 text-sm text-gray-500 font-medium">
              <Calendar className="w-4.5 h-4.5 text-pink-500" />
              <span>Last updated: May 2026</span>
            </div>
          </div>

          {/* Main Card Content */}
          {lookUpCMSData?.["Privacy Policy"] && (
            <div
              className="bg-white rounded-3xl border border-gray-150 p-8 sm:p-12 shadow-sm space-y-10"
              dangerouslySetInnerHTML={{
                __html: lookUpCMSData["Privacy Policy"].Template || "",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
